<template>

    <el-row :gutter="20" class="index_menu">
        <!--        logo区-->
        <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <el-card shadow="never" body-style="backgroundColor: #f8f8f8;">
                <div id="logo_area">
                    <img src="@/assets/img/logoLeft.jpg" alt="">
                    <img src="@/assets/img/logo.png" alt="">
                    <span>JUNFEI TECH</span>
                </div>
            </el-card>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
            <!--导航菜单区-->
            <el-card shadow="never"  body-style="backgroundColor: #f8f8f8">
                <el-menu mode="horizontal"
                         background-color="#f8f8f8"
                         router
                         style="border: none; "
                         default-active="/">

                    <el-menu-item index='/'>首页</el-menu-item>
                    <el-submenu index="/caseshow">
                        <template slot="title"><span>解决方案</span></template>
                        <el-menu-item :index="item.path" v-for="item in caseList" :key="item.id">
                            <!--二级菜单模板区-->
                            <template slot="title">
                                <!--文本-->
                                <span>{{item.name}}</span>
                            </template>
                        </el-menu-item>
                    </el-submenu>
                    <el-submenu index='/smartProduct'>
                        <template slot="title"><span>智能产品</span></template>
                        <el-menu-item :index="item.path" v-for="item in productList" :key="item.id">
                            <!--二级菜单模板区-->
                            <template slot="title">
                                <!--文本-->
                                <span>{{item.name}}</span>
                            </template>
                        </el-menu-item>
                    </el-submenu>
                    <el-menu-item index="/mall" ><a href="http://joyingcloud.com/" target="_blank"
                                                  class="menu_link">商城</a></el-menu-item>
                    <el-menu-item index='/download'>下载中心</el-menu-item>
                    <el-menu-item index="/forum"><a href="http://joyingtec.com/drupal/" target="_blank"
                                                   class="menu_link">数采论坛</a></el-menu-item>
                    <el-menu-item index='/aboutus'>关于钧飞</el-menu-item>
                </el-menu>

            </el-card>

        </el-col>

    </el-row>
</template>

<script>
  export default {
    data() {
      return {
        caseList: [
          {
            id: '3-1',
            path: '/jingqingqidai',
            name: '智能制造'
          },
          {
            id: '3-2',
            path: '/jingqingqidai',
            name: '数字化工厂'
          },
          {
            id: '3-3',
            path: '/jingqingqidai',
            name: '智慧金融'
          },
          {
            id: '3-4',
            path: '/smarthome',
            name: '智能家居'
          },
          {
            id: '3-5',
            path: '/smarteducation',
            name: '智慧教育'
          },
          {
            id: '3-6',
            path: '/librarian',
            name: '无人图书馆'
          }
        ],
        productList: [
          {
            id: '4-1',
            path: '/smartmodule',
            name: '4/5模组'
          },
          {
            id: '4-2',
            path: '/4G',
            name: '4G智能网关'
          },
          {
            id: '4-3',
            path: '/5G',
            name: '5G智能网关'
          },
          {
            id: '4-4',
            path: '/ethernet',
            name: '以太智能网关'
          },
          {
            id: '4-5',
            path: '/jingqingqidai',
            name: '工位一体机'
          },
          {
            id: '4-6',
            path: '/jingqingqidai',
            name: '人脸识别工位机'
          },
          {
            id: '4-7',
            path: '/jingqingqidai',
            name: '安全帽识别盒'
          },
          {
            id: '4-8',
            path: '/jingqingqidai',
            name: '火苗识别盒子'
          },
        ]
      }
    },
  }
</script>

<style lang="less">
    /*注意全局样式的污染*/
    .index_menu {
        /*padding: 10px;*/
        background-color: #f8f8f8;

        #logo_area {
            width: 435px;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            > img {
                width: 56px;
                height: 66px;
                float: right;
                padding-left: 5px;
            }

            > span {
                font-size: 34px;
                color: #777777;
                font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
                line-height: 100%;
                margin-left: 25px;
                float: right;
            }

        }


        .el-menu {
            padding-right: 20px;
            >span {

            }
        }
        .menu_link {
            text-decoration: none;
            font-size: 12px;
        }
        .el-menu-item {
            width: 90px;
            padding: 0;
            text-align: center;
        }

        .el-menu--horizontal > .el-menu-item.is-active {
            border-bottom: 3px solid #E5D276;
        }

        .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
            border-bottom: 3px solid #E5D276 !important;
        }
    }
</style>
